//#region Styles
import { Column, Row } from "components/styles";
//#endregion
//#region Components
import CustomDatePicker from "components/CustomDatePicker/CustomDatePicker";
import CustomSelect from "components/CustomSelect/CustomSelect";
import CustomButton from "components/CustomButton/CustomButton";
//#endregion
//#region Icons
import ClearIcon from "icons/ClearIcon";
import SearchIcon from "icons/SearchIcon";
//#endregion
//#region Utils
import { getOptionsToCustomSelect } from "components/CustomSelect/utils";
import useSpaceCoordinatorCampus from "views/Recursos/ResourcesUniversitySpaces/utils/hooks/useSpaceCoordinatorCampus";
import { FILTER_STYLE_PROPS } from "views/Recursos/ResourcesUniversitySpaces/UniversitySpaceFilters/utils/constants";
import useResourcesUniversitySpacesContext from "../utils/context/useResourcesUniversitySpacesContext";
//#endregion

const UniversitySpaceFilters = ({
    loadingRequest,
    isCampusCoordinator, filters,
    data: {
        campusList,
        // Se encuentran ya cargados
        // spaceTypeList, universityActivityList
    }, header,
    allFilterFieldsWereFilled,
    resetUI
}) => {
    const { spaceList } = useResourcesUniversitySpacesContext();
    //#region Functions
    const changeCampusField = value => {
        filters.change("campusId", value);
    }
    const changeDate = value => {
        filters.change("date", value);
    }
    //#endregion
    const filtersFieldsIsCleared = filters.isCleared();
    useSpaceCoordinatorCampus({
        changeFilter: filters.change,
        isCampusCoordinator
    });
    return (
        <Column marginTop="20px">
            {header}
            <Row width="100%" justifyContent="flex-start" align="flex-end">
                <Row justifyContent="flex-start" align="flex-end">
                    <CustomSelect 
                        {...FILTER_STYLE_PROPS.CUSTOM_SELECT}
                        label="Campus"
                        value={filters.value.campusId}
                        optionsProps={getOptionsToCustomSelect(campusList, { id: "id", text: "name" })}
                        onChange={changeCampusField}
                        disabled={isCampusCoordinator}
                        defaultOptionText="Elige un Campus"/>
                    <CustomDatePicker 
                        label="Fecha"
                        value={filters.value.date}
                        onChange={changeDate}
                        period={{
                            min: [2022, 1, 1],
                            max: [3000, 1, 1]
                        }}/>
                </Row>
                <Row>
                    <CustomButton 
                        {...FILTER_STYLE_PROPS.CUSTOM_BUTTON}
                        onClick={spaceList.triggerFilling}
                        icon={<SearchIcon/>}
                        text="Aplicar"
                        width="100px"
                        disabled={!allFilterFieldsWereFilled}/>
                    <CustomButton 
                        {...FILTER_STYLE_PROPS.CUSTOM_BUTTON}
                        disabled= {filtersFieldsIsCleared}
                        onClick={resetUI}
                        variant={filtersFieldsIsCleared ? "primary" : "secondary"}
                        icon={<ClearIcon/>}
                        text="Limpiar"/>
                </Row>
            </Row>
        </Column>
    );
}

export default UniversitySpaceFilters;